import { render, staticRenderFns } from "./changeRemark2.vue?vue&type=template&id=0f0805d2&scoped=true"
import script from "./changeRemark2.vue?vue&type=script&lang=js"
export * from "./changeRemark2.vue?vue&type=script&lang=js"
import style0 from "./changeRemark2.vue?vue&type=style&index=0&id=0f0805d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0805d2",
  null
  
)

export default component.exports